module.exports = __webpack_public_path__ + "static/media/follow_the_food_farmers_on_front_line_Tablet.045e3189.jpg";